import type { IconSvgObject } from './types';

const CommandIcon: IconSvgObject = [
  ["path", { d: "M15 9V15H9V9H15Z", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M15 15H18C19.6569 15 21 16.3431 21 18C21 19.6569 19.6569 21 18 21C16.3431 21 15 19.6569 15 18V15Z", stroke: "currentColor", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M9 15.002H6C4.34315 15.002 3 16.3451 3 18.002C3 19.6588 4.34315 21.002 6 21.002C7.65685 21.002 9 19.6588 9 18.002V15.002Z", stroke: "currentColor", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M15 9L15 6C15 4.34315 16.3431 3 18 3C19.6569 3 21 4.34315 21 6C21 7.65685 19.6569 9 18 9H15Z", stroke: "currentColor", strokeWidth: "1.5", key: "3" }],
  ["path", { d: "M9 9V6C9 4.34315 7.65685 3 6 3C4.34315 3 3 4.34315 3 6C3 7.65685 4.34315 9 6 9H9Z", stroke: "currentColor", strokeWidth: "1.5", key: "4" }]
];

export default CommandIcon;
